<p *ngFor="let error of errors">
    {{ "API-HANDLER.ERROR-IN-FIELD" | translate }}: {{error.name}}, {{ "API-HANDLER.ERROR-REASON" | translate }}: {{error.value}}
</p>